<script>
    import { createEventDispatcher } from 'svelte'
    // import { Link, navigateTo } from 'yrv'
    import ActionButton from '../../components/ActionButton/ActionButton.svelte'
    // import TouchIcon from '../../components/TouchIcon/TouchIcon.svelte'
    import ListItem from '../../components/ListItem/ListItem.svelte'
    import Dialog from '../../components/Modal/Dialog.svelte'
    // import TagItem from '../../components/Tags/TagItem.svelte'
    // import moment from 'moment'
    

    export let data

    const dispatch = createEventDispatcher ();

    let deleteDialog = false,
        notifyBusy = false

    const deleteItem = (event) => {
        deleteDialog = true
    }

    const editItem = (event) => {
        dispatch ('edit', {
            bean: data
        })
    }

    const cancelDelete = () => {
        deleteDialog = false
    }

    const confirmDelete = () => {
        deleteDialog = false;
        dispatch ('delete', {
            bean: data
        })
    }
</script>

<style>
    .AlertRuleItem .status {
        float: left;
        width: 50px;
        text-align: center;
        padding-top: 8px;
    }
    .AlertRuleItem .meta {
        float: left;
        width: calc(50% - 50px);
    }
    .AlertRuleItem :global(.block) {
        padding: 5px 0;
        /* width: calc(100% - 50px);
        float: left; */
    }
    .AlertRuleItem .ops {
        float: right;
        width: 50%;
        padding-left: 6px;
        text-align: left;
    }


    .AlertRuleItem .lbl {
        font-weight: 600;
    }
    .AlertRuleItem .txt {
        font-size: 12px;
        color: var(--text-secondary);
        line-height: 14px;
    }

    .dialog-meta {
        margin-top: 10px;
    }
    .dialog-meta .lbl {
        font-weight: 600;
    }
    .dialog-meta .txt {
        font-size: 12px;
        color: var(--text-secondary);
        line-height: 14px;
    }
</style>


<div class="AlertRuleItem clearfix">
    <ListItem classes="block clearfix" actions on:click={editItem}>
        <div class="status">
            <i class="far fa-bell-on"></i>
        </div>
        <div class="meta">
            <div class="lbl">{data.client.name}</div>
            <div class="txt">
                {data.description}
            </div>
        </div>
        <div class="ops">
            
        </div>
        
        <div slot="actions">
            <ActionButton icon="far fa-pencil" on:click={editItem} />
            <ActionButton icon="far fa-trash" on:click={deleteItem} />
        </div>
    </ListItem>
</div>


{#if deleteDialog}
    <Dialog 
        title="Vuoi davvero eliminare questa regola?" 
        on:cancel={cancelDelete} 
        on:confirm={confirmDelete}
        leftAlign>
        <div class="dialog-meta">
            <div class="lbl">{data.client.name}</div>
            <div class="txt">{data.description}</div>
        </div>
    </Dialog>
{/if}